import React from 'react';
// Importe seu gif aqui. Se estiver na pasta public, use o caminho string direto.
import loadingGif from '../../assets/gifs/loading.gif'; 

const Loading = ({ 
    fullScreen = true, // Se true, usa fixed (tela toda). Se false, usa absolute (div pai)
    size = 96,         // Tamanho da imagem
    bgColor = 'rgba(255, 255, 255, 0.5)' // Cor de fundo opcional (transparente por padrão no seu código, mas um fundo semi-transparente ajuda o UX)
}) => {
    
    const styles = {
        container: {
            position: fullScreen ? 'fixed' : 'absolute',
            inset: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: bgColor, // Alterado para permitir fundo customizado
            zIndex: 9999,
            borderRadius: fullScreen ? 0 : '8px', // Arredonda bordas se for interno
        },
        image: {
            width: size,
            height: size,
            imageRendering: 'crisp-edges'
        }
    };

    return (
        <div style={styles.container}>
            <img
                src={loadingGif}
                alt="Carregando..."
                style={styles.image}
            />
        </div>
    );
};

export default Loading;